import { render, staticRenderFns } from "./exchangeSonOrder.vue?vue&type=template&id=f942c864"
import script from "./exchangeSonOrder.vue?vue&type=script&lang=ts"
export * from "./exchangeSonOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports